<template>
  <div class="contact_form_box">
    <UiAnim class="animation a-tr" type="lr-100" tag="h2">Напишите нам</UiAnim>

    <form class="contact_form form" @submit.prevent="submit">
      <div class="form-loader" v-if="loading">
        <IconLoader />
      </div>
      <UiAnim type="lr-100" :delay="1" class="from-field">
        <input
          type="text"
          v-model="form.name.value"
          placeholder="Имя *"
          required
          maxlength="50"
          :class="{ error: form.name.classError }"
          @focus="form.name.focus"
          @blur="form.name.blur"
        />
        <p v-if="form.name.showError" class="error">
          Минимальная длина поля "Имя" 3 символа
        </p>
      </UiAnim>
      <UiAnim type="lr-100" :delay="2" class="from-field">
        <input
          type="email"
          placeholder="E-mail *"
          required
          v-model="form.email.value"
          :class="{ error: form.email.classError }"
          @focus="form.email.focus"
          @blur="form.email.blur"
        />
        <p v-if="form.email.showError" class="error">
          Введите корректный E-mail
        </p>
      </UiAnim>
      <UiAnim type="lr-100" :delay="3" class="from-field">
        <textarea
          cols="1"
          rows="1"
          v-model="form.message.value"
          placeholder="Ваше сообщение *"
          :class="{ error: form.message.classError }"
          @focus="form.message.focus"
          @blur="form.message.blur"
          required
        ></textarea>
        <p v-if="form.message.showError" class="error">
          Заполните поле "Сообщение" 20-1000 символов
        </p>
      </UiAnim>
      <UiAnim type="lr-100" :delay="4"
        ><button type="submit" :class="{ disabled: loading || !form.valid || !accept }">
          Отправить
        </button>
      </UiAnim>
    </form>
    <UiAnim type="lr-100" :delay="5">
      <UiConditionsLink v-model="accept" />
    </UiAnim>
  </div>
  <Teleport to="body">
    <UiAlert v-if="alert" @closed="alert = null" :text="alert" />
  </Teleport>
</template>

<script setup>
import { useForm, form2Body, clearForm } from "~/helpers/form";
import {
  minLength,
  maxLength,
  checkEmail,
  required,
} from "~/helpers/validators";
const loading = ref();
const alert = ref();
const accept = ref(false);

const form = useForm({
  name: {
    value: "",
    validators: { required, minLength: minLength(3) },
  },
  email: {
    value: "",
    validators: { required, checkEmail },
  },
  message: {
    value: "",
    validators: {
      required,
      minLength: minLength(20),
      maxLength: maxLength(1000),
    },
  },
});

const submit = async () => {
  if (!form.valid || loading.value || !accept.value) return;
  useMetrika("form");
  loading.value = true;
  const res = await $fetch("/api/submit", {
    method: "POST",
    body: form2Body(form, "contact"),
  });
  loading.value = false;
  accept.value = false;
  clearForm(form);
  if (res?.success) {
    alert.value =
      "Ваше сообщение отправлено. Мы свяжемся с Вами в ближайшее время.";
  } else alert.value = -1;
};
</script>
